import {ProfileModel} from "../../features/profile/profileTypes";
import React from "react";
import ProfileSeasonItem from "./ProfileSeasonItem";
import Trophies from "./Trophies";
import EditIcon from "./EditIcon";

type Props = {
    profile: ProfileModel
};

const RightContent = ({profile}: Props) => {
    return (
        <div className='px-1 ps-md-0 pe-md-2 py-2 anim-delay-medium'>
            {profile.trophies.length > 0 &&
                <div className='bg-main-darker mb-2 p-1 slide-right'>
                    <p className='mb-1 text-grey'><small>TROPHIES</small></p>
                    <Trophies trophies={profile.trophies}/>
                </div>
            }

            {profile.about &&
                <div className='bg-main-darker mb-2 p-1 editable slide-righ'>
                    <p className='mb-1 text-grey'><small>ABOUT</small>
                        <EditIcon />
                    </p>
                    <div className='about-text'>
                        {profile.about}
                    </div>
                </div>
            }

            {profile.seasons.length > 0 &&
                <div className='bg-main-darker mb-2 p-1 slide-right'>
                    <p className='mb-1 text-grey'><small>SEASONS</small></p>
                    <div className='row'>
                        {profile.seasons.map((season) => (
                            <div className='col-md-6' key={season.id}>
                                <ProfileSeasonItem season={season}/>
                            </div>
                        ))}
                    </div>
                </div>
            }

            {!profile.seasons.length && !profile.about && !profile.trophies.length &&
                <p className='editable'>
                    <i>This user hasn't completed their profile.</i>
                    <EditIcon />
                </p>
            }
        </div>
    )
}

export default RightContent;
